// Lightweight native replacement for the `saveAs` helper from `file-saver`,
// which was removed from the dependency set during the Arcadia migration.
export function saveAs(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
